import React from "react";
import PropTypes from "prop-types";
import Gauge from "../../../casper/sass/components/gauge";

const GetMarkerStatus = status => {
  switch (status) {
    case "very_low":
    case "moderate":
      return "Caution";
    case "very_high":
    case "high":
      return "Danger";
    case "low":
    default:
      return "Normal";
  }
};

export const GetRangeValues = data => {
  const values = {
    value: parseFloat(data.userValue ? data.userValue : data.labResultValue),
    minValue: 0,
    maxValue: 0,
    maxDiff: 0,
    rangeData: [],
  };

  if (data.valueRanges) {
    for (const sample of data.valueRanges) {
      if (sample.lowerLimit < values.minValue) {
        values.minValue = sample.lowerLimit;
      }

      if (sample.upperLimit < 99999) {
        const diff = sample.upperLimit - sample.lowerLimit;

        if (diff > values.maxDiff) {
          values.maxDiff = diff;
        }
      } else {
        sample.upperLimit = sample.lowerLimit + values.maxDiff;
      }

      if (sample.upperLimit > values.maxValue) {
        values.maxValue = sample.upperLimit;
      }

      values.rangeData.push({
        start: sample.lowerLimit,
        end: sample.upperLimit,
        status: GetMarkerStatus(sample.description),
      });
    }
  } else {
    values.minValue = 0;

    const range = data.labResultRange
      .replace("(", "")
      .replace(")", "")
      .replace(" ", "");
    // There are 3 possible options: <X, >X, X-Y:
    let rangeValues = range.split("-");

    if (rangeValues.length > 1) {
      const minNormal = parseFloat(rangeValues[0]);
      const maxNormal = parseFloat(rangeValues[1]);

      values.maxValue = maxNormal * 2;

      if (values.value >= values.maxValue) {
        values.maxValue = values.value + values.value / 10;
      }

      values.rangeData.push({
        start: 0,
        end: minNormal,
        status: "Danger",
      });

      values.rangeData.push({
        start: minNormal,
        end: maxNormal,
        status: "Normal",
      });

      values.rangeData.push({
        start: maxNormal,
        end: values.maxValue,
        status: "Danger",
      });
    }

    if (range.charAt(0) == ">") {
      rangeValues = range.split(">");

      const minNormal = parseFloat(rangeValues[1]);

      values.maxValue = minNormal * 2;

      if (values.value >= values.maxValue) {
        values.maxValue = values.value + values.value / 10;
      }

      values.rangeData.push({
        start: 0,
        end: minNormal,
        status: "Danger",
      });

      values.rangeData.push({
        start: minNormal,
        end: values.maxValue,
        status: "Normal",
      });
      return values;
    }

    if (range.charAt(0) == "<") {
      rangeValues = range.split("<");

      const maxNormal = parseFloat(rangeValues[1]);

      values.maxValue = maxNormal * 2;

      if (values.value >= values.maxValue) {
        values.maxValue = values.value + values.value / 10;
      }

      values.rangeData.push({
        start: 0,
        end: maxNormal,
        status: "Normal",
      });

      values.rangeData.push({
        start: maxNormal,
        end: values.maxValue,
        status: "Danger",
      });
    }
  }

  return values;
};

const MarkerRange = ({ data }) => {
  const { ranges, rangeValue, value, status } = data;
  const minValue = Math.min(...ranges.map(range => range.range[0]));
  const maxValue = Math.max(...ranges.map(range => range.range[1]));

  return (
    <figure className="apl-marker__range">
      <Gauge
        min={minValue}
        max={maxValue}
        value={rangeValue}
        ranges={ranges}
        showMinMax={false}
      />
    </figure>
  );
};

MarkerRange.propTypes = {
  data: PropTypes.object,
};

export default MarkerRange;



// WEBPACK FOOTER //
// ./components/employee/wellness/markerRange.jsx